import React, { useRef, useEffect, useState } from 'react';
import { MapContainer, TileLayer, GeoJSON, Popup } from 'react-leaflet';
import LegendMap from './LegendMap';
import { useGeoJson } from '../state/GeojsonContext';
import GeojsonLayer from './GeojsonLayer';
import PositionedSnackbar from './PositionedSnackbar';
import config from "../config";
import createGeoJSONTemplate from '../geojsonTemplate';
import LegendRate from './LegendRate';

function Map() {
    const mapRef = useRef(null);
    const { geojsonData } = useGeoJson();

    const [dataRegions, setDataRegions] = useState(null);

    useEffect(() => {
        fetch(`${config.serverUrl}/api/regions_data`)
            .then((response) => response.json())
            .then((fetchedData) => {
                const geom_dict = JSON.parse(fetchedData.geom_geojson);
                const geojson_geom_dict = createGeoJSONTemplate(geom_dict);
                setDataRegions(geojson_geom_dict);
            })
            .catch((error) => console.error('Error:', error));
    }, []);

    return (
        <div>
            <PositionedSnackbar />
            <LegendMap />
            <LegendRate />
            <MapContainer
                ref={mapRef}
                center={[54.293717, 16.758439]}
                zoom={8}
                style={{ width: '100%', height: "100vh" }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {geojsonData && geojsonData.length > 0 &&
                    <GeojsonLayer map={mapRef} geojsonData={geojsonData} />
                }
                {dataRegions && (
                    <GeoJSON key={"data-regions"} data={dataRegions}
                        style={{
                            color: "#474643",
                            borderWeight: 0.2,
                            opacity: 1,
                            fillOpacity: 0
                        }}
                    />
                )}
            </MapContainer >
        </div>
    );
}

export default Map;